<script lang="ts">
import dayjs from "dayjs";
import RemoveButton from "$lib/components/ui/RemoveButton.svelte";
import {Button, Modal} from "flowbite-svelte";
import {FileCopySolid, PenSolid} from "flowbite-svelte-icons";
import {getTariffs, retireTariff} from "$lib/calls/tariff";
import {tariffs} from "$lib/stores/tariffs";
import TariffDetailsModal from "$lib/partials/settings/TariffDetailsModal.svelte";

export let value: number

export let qualifications;

let confirmModel = false;

$:currentTariff = $tariffs.find(x => x.id === value)

let detailModal = false;
const openDetailModal = tariff => {
    currentTariff = tariff;
    detailModal = true;
}


const deleteTariffConfirm = id => {
    confirmModel = true;
    currentTariff = $tariffs.find(x => x.id === id)
}
const deleteTariff = () => {
    retireTariff(currentTariff).then(() => {
        confirmModel = false;
        $tariffs = [...$tariffs.filter(x => x.id !== currentTariff.id)]
    })
}

</script>
<div class="flex gap-2">
    <Button class="!p-2" pill on:click={() => openDetailModal(currentTariff)}>
        <PenSolid class="w-4 h-4"/>
    </Button>
    <Button color="light" class="!p-2" pill on:click={() => openDetailModal({...currentTariff, id:null, name: currentTariff.name + ' - copy', validFrom: dayjs(currentTariff.validFrom.value).format('YYYY-MM-DD')})}>
        <FileCopySolid class="w-4 h-4"/>
    </Button>
    <RemoveButton value={currentTariff?.id} onClick={() => deleteTariffConfirm(currentTariff?.id)}/>
</div>

<TariffDetailsModal extract={() => getTariffs().then(x => $tariffs = x)} bind:open={detailModal} bind:currentTariff   />
<Modal size="xs" title="Hinweis" bind:open={confirmModel}>
    <p>
        Löschen eines Tarifes beeinflusst nicht bestehende Verträge. <br>
        Möchten Sie den Tarif <span class="font-bold">"{currentTariff.name}"</span> löschen?
    </p>
    <div class="text-center">
        <Button color="red" class="mr-2" on:click={deleteTariff}>Ja, löschen</Button>
        <Button color="alternative" on:click={() => confirmModel = false}>Nein, abbrechen</Button>
    </div>
</Modal>